import { cn } from '@speedlo/ui'
import React from 'react'
import Spinner from 'react-spinkit'

interface IProps {
  address: string
  isVisible: boolean
  isResolving: boolean
  onValidClick(): void
}

export const ResolvedAddress: React.FC<IProps> = ({
  address,
  isVisible,
  isResolving,
  onValidClick,
}) => {
  return (
    <div
      data-testid="ResolvedAddress"
      className={cn('resolved__address', {
        wait: isResolving,
        hidden: !isVisible,
      })}
      onClick={isResolving ? undefined : onValidClick}
    >
      {isResolving ? <Spinner name="ball-beat" fadeIn="none" /> : address}
    </div>
  )
}
